'use client'

import PlausibleProvider from 'next-plausible'
import type { ReactNode } from 'react'
import { IntlProvider } from 'react-intl'

import { Layout } from './client-layout'

const LOCALE = 'en-GB'

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <IntlProvider locale={LOCALE} onError={() => ({})}>
      <PlausibleProvider
        domain="design.landfolk.com"
        enabled={__IS_PRODUCTION__}
      >
        <Layout>{children}</Layout>
      </PlausibleProvider>
    </IntlProvider>
  )
}
